import React from "react";
import { useState, useEffect } from "react";
import {
   Pie,
   PieChart,
   Cell,
   ComposedChart,
   Bar,
   Line,
   BarChart,
   AreaChart,
   Area,
   XAxis,
   YAxis,
   CartesianGrid,
   Tooltip,
   ReferenceLine,
   Legend,
   ResponsiveContainer,
   LabelList,
} from "recharts";
import {
   api,
   formatCurrency,
   getDateSpanArray,
   getStaticData,
   httpPost,
   parseOODate,
   parsePreisliste,
} from "../pureFunctions";
import { colorPalette100, header, host, averageString } from "../globalVariables";
import { useConfig } from "../ConfigContext";
import { Form, Col, Button, Row, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { getAppointments } from "../networkFunctions";
import { values } from "lodash";
import MySelect from "../MySelect";
import { CustomTermineLabel, CustomTooltip } from "./CustomRechartUtils";
import VerkaufsdatenPreisSpanne from "./VerkaufsdatenPreisSpanne";
import VerkaufsdatenTable from "./VerkaufsdatenTable";

const tableHeader = [
   { key: "objektnr_extern", value: "Objektnummer" },
   { key: "objektBezeichnung", value: "Objektbezeichnung" },
   { key: "einkaeufer", value: "Einkäufer" },
   { key: "benutzer", value: "Verkäufer" },
   { key: "quelle", value: "Quelle" },
   { key: "verkaufsstatus", value: "Status" },
   { key: "verkauftFur", value: "Verkauft für" },
   { key: "kaufpreis", value: "ursp. Preis" },
];

const lsOptionKey = "VerkaufsdatenOpt";
const initialFilterParams = {
   dateField: "erstellt_am",
   dateField2: "",
   sortField: "",
   startDate: new Date("01.01." + new Date().getFullYear()),
   endDate: new Date("12.31." + new Date().getFullYear()),
   startDate2: new Date("01.01." + new Date().getFullYear()),
   endDate2: new Date("12.31." + new Date().getFullYear()),
   startDateTermin: new Date("01.01." + new Date().getFullYear()),
   endDateTermin: new Date("12.31." + new Date().getFullYear()),
   terminArten: "",
   quelle: [],
   // terminArten: [],
   einkaeufer: [],
   benutzer: [],
   vollmachtsdatum: false,
   status2: [],
};

export default function Verkaufsdaten({}) {
   const config = useConfig();
   const [filterParams, setFilterParams] = useState(() => {
      let prevOptions;
      try {
         prevOptions = JSON.parse(localStorage.getItem(lsOptionKey));
      } catch (error) {
         prevOptions = initialFilterParams;
      }

      console.log(prevOptions);

      return prevOptions ?? initialFilterParams;
   });
   const [accData, setAccData] = useState();
   const [quelleData, setQuelleData] = useState();
   const [accQuelleData, setAccQuelleData] = useState();
   const [vkStatusData, setVkStatusData] = useState();
   const [accVkStatusData, setAccVkStatusData] = useState();
   const [users, setUsers] = useState();
   const [oOFields, setOOFields] = useState();
   const [estateData, setEstateData] = useState();
   const [tableData, setTableData] = useState();
   const [terminData, setTerminData] = useState();
   const [terminEstateData, setTerminEstateData] = useState();
   const [sortTerminResultKey, setSortTerminResultKey] = useState("Quote");
   const [showDetails, setShowDetails] = useState({ verkaufsstatus: false, quelle: false });

   async function getTerminData() {
      // if (filterParams.terminArten.length > 0 && filterParams.terminArten[0]) {
      if (filterParams.terminArten) {
         console.log("Getting Termine");

         let allTermine = {};
         let allTerminEstates = {};

         const dateSpanArray = getDateSpanArray(filterParams.startDateTermin, filterParams.endDateTermin);

         const allTerminResponse = await Promise.all(
            dateSpanArray.map((dateSpan) => {
               let timeLimit = parseOODate(dateSpan[0], dateSpan[1]);

               let parameters = {
                  data: [
                     "id",
                     /* "type", "subject", "notes",  */
                     "estate",
                     "status",
                     "date",
                     "users",
                     /* , "contacts" */
                  ],
                  filter: {
                     startDate: timeLimit[0],
                     endDate: timeLimit[1],
                     isCancelled: false,
                     type: [{ op: "IN", val: [filterParams.terminArten] }],
                     ...(filterParams?.einkaeufer?.length
                        ? {
                             userIds: filterParams.einkaeufer,
                          }
                        : {}),

                     /* ...(filterParams.einkaeufer || filterParams.benutzer
                        ? {
                             userIds: [
                                ...(filterParams.einkaeufer ? [filterParams.einkaeufer] : []),
                                ...(filterParams.benutzer ? [filterParams.benutzer] : []),
                             ],
                          }
                        : {}),
                      */
                     // type: [{ op: "IN", val: filterParams.terminArten }],
                     // userIds: config.glMeetingCalenderUsers,
                  },
               };
               console.log(parameters);

               let terminResponse = getAppointments(parameters).then((data) => {
                  console.log(data);
                  allTerminEstates = {
                     ...allTerminEstates,
                     ...data
                        .filter((item) => item.elements?.estate?.id)
                        .reduce(
                           (oldObj, item) => ({ ...oldObj, [item.elements.estate.id]: { date: item.elements.date } }),
                           {},
                        ),
                  };

                  let accUsr = {};
                  data.forEach((item) => {
                     accUsr[item.elements?.users?.[0]?.id] = (accUsr[item.elements?.users?.[0]?.id] || 0) + 1;
                  });
                  console.log(accUsr);

                  let terminAccData = {
                     name: dateSpan[0].getMonth() + 1 + "." + (dateSpan[0].getFullYear() - 2000),
                     Anzahl: data.length,
                     ...accUsr,
                  };
                  return { dateSpan: dateSpan, data: data, graph: terminAccData };
               });

               return terminResponse;
            }),
         );
         console.log(allTerminEstates);
         getTerminEstateData(allTerminEstates);

         setTerminData(allTerminResponse);
         console.log(allTerminResponse);
      }
   }

   async function getTerminEstateData(terminEstates) {
      let parameters = {
         data: [
            config.estate.einkaeufer,
            "status2",
            /* 
            ...config.verkaufsDaten.requestParams.data,
            ...(filterParams.dateField ? [filterParams.dateField] : []),
            ...(filterParams.dateField2 ? [filterParams.dateField2] : []), */
         ],
         filter: {},
         listlimit: 500,
         listoffset: 0,
         sortby: { [filterParams.sortField || "objektnr_extern"]: "DESC" },
      };
      parameters.filter.Id = [{ op: "IN", val: Object.keys(terminEstates) }];
      if (filterParams.dateField) {
         parameters.filter[filterParams.dateField] = [
            { op: "BETWEEN", val: parseOODate(filterParams.startDate, filterParams.endDate) },
         ];
      }
      if (filterParams.dateField2) {
         parameters.filter[filterParams.dateField2] = [
            { op: "BETWEEN", val: parseOODate(filterParams.startDate2, filterParams.endDate2) },
         ];
      }
      console.log(filterParams);
      console.log(filterParams.quelle?.length > 0);

      if (filterParams.quelle?.length > 0) {
         parameters.filter[config.estate.quelle] = [{ op: "IN", val: filterParams.quelle }];
      }
      if (filterParams.einkaeufer?.length > 0) {
         parameters.filter[config.estate.einkaeufer] = [{ op: "IN", val: filterParams.einkaeufer }];
      }
      if (filterParams.benutzer?.length > 0) {
         parameters.filter.benutzer = [{ op: "IN", val: filterParams.benutzer }];
      }
      console.log(parameters);

      let respdata = await api
         .post("/api/readEstates", { parameters }, header)
         .then((data) => {
            console.log(data);

            setTerminEstateData(data.data);
         })
         .catch((err) => {
            console.log(err);
         });
   }
   async function getData() {
      let parameters = {
         data: [
            ...config.verkaufsDaten.requestParams.data,
            ...(filterParams.dateField ? [filterParams.dateField] : []),
            ...(filterParams.dateField2 ? [filterParams.dateField2] : []),
         ],
         filter: {},
         listlimit: 500,
         listoffset: 0,
         sortby: { [filterParams.sortField || "objektnr_extern"]: "DESC" },
      };

      if (filterParams.status2.length) {
         parameters.filter["status2"] = [
            {
               op: "IN",
               val: filterParams.status2,
            },
         ];
      }
      if (filterParams.dateField) {
         parameters.filter[filterParams.dateField] = [
            { op: "BETWEEN", val: parseOODate(filterParams.startDate, filterParams.endDate) },
         ];
      }
      if (filterParams.dateField2) {
         parameters.filter[filterParams.dateField2] = [
            { op: "BETWEEN", val: parseOODate(filterParams.startDate2, filterParams.endDate2) },
         ];
      }

      if (filterParams.quelle?.length > 0) {
         parameters.filter[config.estate.quelle] = [{ op: "IN", val: filterParams.quelle }];
      }
      if (filterParams.einkaeufer?.length > 0) {
         parameters.filter[config.estate.einkaeufer] = [{ op: "IN", val: filterParams.einkaeufer }];
      }
      if (filterParams.benutzer?.length > 0) {
         parameters.filter.benutzer = [{ op: "IN", val: filterParams.benutzer }];
      }

      console.log(parameters);

      let respdata = await api.post("/api/readEstates", { parameters }, header).then((data) => {
         let tortenStatus = structuredClone(config.verkaufsDaten.tortenStatus);
         let abweichungGrenzwert, priceLevel, mittelwert, abweichung, spanne, einkaufstermin, jsonData, accumulatedData;
         let tortenQuelle = {};

         if (config.company === "baur") {
            accumulatedData = {
               over: { name: "Über", value: 0, color: "#0c0", abweichung: 0 },
               inside: { name: "Passend", value: 0, color: "#080", abweichung: 0 },
               under: { name: "Unter", value: 0, color: "#b00", abweichung: 0 },
               fixed: { name: "Fix", value: 0, color: "#339", abweichung: 0 },
               undef: { name: "Undefiniert", value: 0, color: "#000", abweichung: 0 },
            };
         }
         let cleanResponse = data.data.map((item) => {
            if (config.company === "bender") {
               const currentQuellen = item.elements[config.estate.quelle];

               currentQuellen.forEach((currentQuelle) => {
                  let name = oOFields?.estate?.[config.estate.quelle]?.permittedvalues[currentQuelle];
                  if (tortenQuelle[name]) {
                     tortenQuelle[name].value++;
                     tortenQuelle[name].objektnr_extern.push(item.elements.objektnr_extern);
                  } else {
                     tortenQuelle[name] = {
                        value: 1,
                        name: name,
                        color: colorPalette100[Object.keys(tortenQuelle).length],
                        objektnr_extern: [item.elements.objektnr_extern],
                     };
                  }
               });
            }
            if (config.company === "baur" && config.estate.quelle && item.elements[config.estate.quelle]) {
               const currentQuelle = item.elements[config.estate.quelle];
               if (tortenQuelle[currentQuelle]) {
                  tortenQuelle[currentQuelle].value++;
                  tortenQuelle[currentQuelle].objektnr_extern.push(item.elements.objektnr_extern);
               } else {
                  tortenQuelle[currentQuelle] = {
                     value: 1,
                     name: currentQuelle,
                     color: colorPalette100[Object.keys(tortenQuelle).length],
                     objektnr_extern: [item.elements.objektnr_extern],
                  };
               }
            }
            if (config.estate.verkaufsStatus) {
               const currentVKStatus = item.elements[config.estate.verkaufsStatus];
               if (tortenStatus[currentVKStatus]?.value) {
                  tortenStatus[currentVKStatus].value++;
                  tortenStatus[currentVKStatus].objektnr_extern.push(item.elements.objektnr_extern);
               } else {
                  tortenStatus[currentVKStatus] = {
                     value: 1,
                     name: currentVKStatus,
                     color: tortenStatus[currentVKStatus]?.color ?? "#0ff",
                     objektnr_extern: [item.elements.objektnr_extern],
                     category: tortenStatus[currentVKStatus]?.category ?? "Sonstige",
                  };
               }
            }
            if (config.estate.JSONFeldname && item.elements[config.estate.JSONFeldname]) {
               try {
                  jsonData = JSON.parse(item.elements[config.estate.JSONFeldname]);
               } catch (error) {
                  console.log(item.elements[config.estate.JSONFeldname]);
               }
               einkaufstermin = jsonData["einkaufstermin_am"] ? new Date(jsonData["einkaufstermin_am"]) : false;

               spanne = jsonData
                  ? [
                       jsonData["bb_minw"] ? parseFloat(jsonData["bb_minw"]) : 0,
                       jsonData["bb_maxw"] ? parseFloat(jsonData["bb_maxw"]) : 0,
                    ]
                  : [0, 0];
               if (jsonData?.["dbin_a_o_b"] === "Auftrag") {
                  spanne = [item.elements[config.estate.verkauftFur], item.elements[config.estate.verkauftFur]];
               }

               if (jsonData && spanne[0] && spanne[1] && parseFloat(item.elements[config.estate.verkauftFur]) > 0) {
                  if (item.elements[config.estate.verkauftFur] < spanne[0]) {
                     priceLevel = "under";
                     abweichungGrenzwert =
                        Math.round((item.elements[config.estate.verkauftFur] / spanne[0]) * 100) - 100;

                     accumulatedData.under.abweichung += abweichungGrenzwert;
                  } else if (item.elements[config.estate.verkauftFur] > spanne[1]) {
                     priceLevel = "over";

                     abweichungGrenzwert =
                        Math.round((item.elements[config.estate.verkauftFur] / spanne[1]) * 100) - 100;
                     accumulatedData.over.abweichung += abweichungGrenzwert;
                  } else if (
                     item.elements[config.estate.verkauftFur] === spanne[0] &&
                     item.elements[config.estate.verkauftFur] === spanne[1]
                  ) {
                     priceLevel = "fixed";
                  } else {
                     priceLevel = "inside";
                  }
               } else {
                  priceLevel = "undef";
               }
               accumulatedData[priceLevel].value++;
            }

            let zeitSpanne;
            let ekZeitSpanne;

            if (einkaufstermin) {
               ekZeitSpanne = Math.round(
                  Math.abs(
                     (new Date(item.elements[filterParams.dateField]) - new Date(einkaufstermin)) / (3600000 * 24),
                  ),
               );
            }

            if (filterParams.dateField && filterParams.dateField2) {
               zeitSpanne = Math.abs(
                  (new Date(item.elements[filterParams.dateField]) - new Date(item.elements[filterParams.dateField2])) /
                     (3600000 * 24),
               );
            }
            let preisVerlauf;
            if (config.estate.preisVerlauf && item.elements[config.estate.preisVerlauf]) {
               const parsedPL = item.elements[config.estate.preisVerlauf]
                  ? parsePreisliste(item.elements[config.estate.preisVerlauf])
                  : [];

               preisVerlauf =
                  parsedPL.length > 1
                     ? [parsedPL[parsedPL.length - 1].preis, parsedPL[0].preis]
                     : [
                          parseFloat(item.elements[config.estate.verkauftFur]),
                          parseFloat(item.elements[config.estate.verkauftFur]),
                       ];
            }

            if (config.estate.verkauftFur && item.elements[config.estate.verkauftFur]) {
               mittelwert = false;
               abweichung = false;
               if (spanne && spanne[0] && parseFloat(item.elements[config.estate.verkauftFur]) > 0) {
                  mittelwert = (spanne[0] + spanne[1]) / 2;
                  abweichung = Math.round((item.elements[config.estate.verkauftFur] / mittelwert) * 100) - 100;
                  /* if (item.elements[config.estate.verkauftFur] < spanne[0]) {
                  abweichungGrenzwert = Math.round((item.elements[config.estate.verkauftFur] / spanne[0]) * 100) - 100;
               } else if (item.elements[config.estate.verkauftFur] > spanne[1]) {
                  abweichungGrenzwert = Math.round((item.elements[config.estate.verkauftFur] / spanne[1]) * 100) - 100;
               } */
               }
            }

            return {
               preisVerlauf: preisVerlauf,
               priceLevel: priceLevel,
               estateId: item.id,
               objektnr_extern: item.elements.objektnr_extern,
               quelle: item.elements[config.estate.quelle],
               einkaeufer: item.elements[config.estate.einkaeufer],
               benutzer: item.elements.benutzer,
               name: item.elements.objektnr_extern,
               objektBezeichnung: item.elements[config.estate.objektBezeichnung],
               verkaufsstatus: item.elements[config.estate.verkaufsStatus],
               kaufpreis: parseFloat(item.elements.kaufpreis),
               verkauftFur: parseFloat(item.elements[config.estate.verkauftFur]),
               abgehakt: item.elements[config.estate.objektAbgehakt],
               spanne: spanne,
               zeitSpanne: zeitSpanne,
               ekZeitSpanne: ekZeitSpanne,
               mittelwert: mittelwert,
               abweichung: abweichung,
               abweichungGrenzwert: abweichungGrenzwert,
               sonstiges: jsonData,
               ...(config.company === "baur"
                  ? {
                       vollmachtsdatum: item.elements[config.estate.Vollmachtsdatum],
                       onlinestellungsdatum: item.elements[config.estate.Onlinestellungsdatum],
                       annikasFeld: item.elements?.ind_3538_Feld_ObjVerwaltung349 === "1" ? true : false,
                    }
                  : {}),
               // letzte_aktion: item.elements.letzte_aktion,
            };
         });

         console.log(accumulatedData);
         console.log(tortenQuelle);
         console.log(tortenStatus);

         let newAccTortenStatus = structuredClone(config.verkaufsDaten.accTortenStatus);
         Object.keys(tortenStatus).forEach((item) => {
            let myKey = tortenStatus[item]?.category ?? "Sonstige";
            newAccTortenStatus[myKey].value += tortenStatus[item]?.value ?? 0;
         });

         console.log(newAccTortenStatus);
         setAccVkStatusData(newAccTortenStatus);
         console.log(Object.fromEntries(Object.entries(tortenStatus).filter(([key, value]) => value.value > 0)));

         setVkStatusData(Object.fromEntries(Object.entries(tortenStatus).filter(([key, value]) => value.value > 0)));

         if (tortenQuelle) {
            let sonstigesLimit = (cleanResponse.length * config.verkaufsDaten.sonstigeLimit) / 100;
            let cleanTortenQuelle;

            if (config.company === "bender") {
               cleanTortenQuelle = Object.values(tortenQuelle).filter(
                  (item) =>
                     !filterParams.quelle
                        .map((item) => oOFields?.estate?.[config.estate.quelle]?.permittedvalues?.[item] ?? item)
                        .includes(item.name),
               );
            } else {
               cleanTortenQuelle = Object.values(tortenQuelle);
            }
            let sonstigeQuelle = cleanTortenQuelle.filter((item) => item.value < sonstigesLimit && item.name !== "IMV");

            console.log(sonstigeQuelle);
            setQuelleData(cleanTortenQuelle);

            setAccQuelleData([
               ...cleanTortenQuelle.filter((item) => item.value >= sonstigesLimit || item.name === "IMV"),
               {
                  value: sonstigeQuelle.reduce((prev, current) => prev + current.value, 0),
                  name: "Sonstige",
                  color: "#666",
                  objektnr_extern: sonstigeQuelle.reduce((prev, current) => [...prev, ...current.objektnr_extern], []), //[item.elements.objektnr_extern],
               },
            ]);
         }
         setAccData(accumulatedData);
         return cleanResponse;
      });

      console.log(respdata);
      setTableData(respdata);
      setEstateData(respdata);
   }

   

   async function sendSpecificData(myfieldname, mydata) {
      console.log(mydata);
      // let myKey = "abvm_anforderdatum";
      // let myKey = "exes_fb_dat";
      let myKey = "letzte_aktion";
      let oOFieldname = "ind_3506_Feld_ObjTech347";
      // let oOFieldname = config.estate.ooVollmachtsdatum;

      console.log(parseOODate(mydata[myKey]));

      if (mydata[myKey]) {
         await httpPost(
            host + "/api/updateSpecificEstateField",
            {
               estateId: mydata.estateId,
               oOdata: { [oOFieldname]: parseOODate(mydata[myKey])[0] },
               // oOdata: { [ooFieldname]: parseOODate(mydata.sonstiges[myKey])[0] },
            },
            () => {},
            () => {},
         );
      }
   }

   async function getInitialdata() {
      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();
      console.log(newfieldConfiguration.estate);

      setOOFields(newfieldConfiguration);
      setUsers(cleanUserData);
   }

   useEffect(() => {
      getInitialdata();
   }, []);

   function changeFilterParams(data, key, multiselect) {
      let prevFilterParams = structuredClone(filterParams);
      if (multiselect) {
         prevFilterParams[data] = prevFilterParams[data].includes(key)
            ? prevFilterParams[data].filter((item) => item !== key)
            : [...prevFilterParams[data], key];
      } else {
         prevFilterParams[key ?? data.target.name] = key ? data : data.target.value;
      }
      localStorage.setItem(lsOptionKey, JSON.stringify(prevFilterParams));

      setFilterParams(prevFilterParams);
   }

   return (
      <div>
         {/* <Button
            onClick={async () => {
               for (const item of tableData) {
                  await sendSpecificData("myfieldname", item);
               }
            }}
         >
            Objekte ändern
         </Button> */}
         <Form className="m-5">
            {/* <Row className="mb-1">
               <div className="me-1">
                  <Button
                     variant={filterParams.vollmachtsdatum ? "dark" : "secondary"}
                     onClick={() => {
                        setFilterParams((prev) => {
                           return { ...prev, vollmachtsdatum: !prev.vollmachtsdatum };
                        });
                     }}
                  >
                     Sonderfilter für Objekte mit Vollmachtskacheldatum von 2026{" "}
                     {filterParams.vollmachtsdatum ? " setzen" : "nicht setzen"}
                  </Button>
               </div>
            </Row> */}
            {/* <Form.Group as={Col} controlId={"id_datumsfeld"} className="mb-2 mt-2">
                  <Form.Label>Terminarten</Form.Label>
                  <Form.Select
                     value={""}
                     onChange={(e) => {
                        setFilterParams((prev) => ({
                           ...prev,
                           terminArten: [...(prev["terminArten"] ?? []), e.target.value],
                        }));
                     }}
                  >
                     <option></option>
                     {config.verkaufsDaten.terminArten.map((keyItem, index) => (
                        <option key={"_" + keyItem} value={keyItem}>
                           {keyItem}
                        </option>
                     ))}
                  </Form.Select>
                  {filterParams.terminArten?.map((selectedStatus) => (
                     <button
                        key={"selectedStatusOpt_" + selectedStatus}
                        className="benutzer-button"
                        name={selectedStatus}
                        onClick={(e) => {
                           e.preventDefault();
                           setFilterParams((prev) => {
                              const newListenOptionen = structuredClone(prev);
                              newListenOptionen["terminArten"] = newListenOptionen.terminArten.filter(
                                 (item) => item != selectedStatus,
                              );
                              return newListenOptionen;
                           });
                        }}
                     >
                        {selectedStatus} {" ×"}
                     </button>
                  ))}
               </Form.Group> */}

            <Row>
               <Form.Group as={Col} controlId={"id_datumsfeld"} className="mb-2 mt-2">
                  <Form.Label>Verkaufsstatus</Form.Label>
                  <Form.Select
                     value={""}
                     onChange={(e) => {
                        let prevFilterParams = structuredClone(filterParams);
                        prevFilterParams["status2"] = [...(prevFilterParams["status2"] ?? []), e.target.value];
                        localStorage.setItem(lsOptionKey, JSON.stringify(prevFilterParams));
                        setFilterParams(prevFilterParams);
                     }}
                  >
                     <option></option>
                     {oOFields?.estate?.status2?.permittedvalues &&
                        Object.keys(oOFields?.estate?.status2?.permittedvalues).map((status) => (
                           <option key={"statusOpt_" + status} value={status}>
                              {oOFields?.estate?.status2?.permittedvalues[status]}
                           </option>
                        ))}
                  </Form.Select>
                  {filterParams.status2?.map((selectedStatus) => (
                     <button
                        key={"selectedStatusOpt_" + selectedStatus}
                        className="benutzer-button"
                        name={selectedStatus}
                        onClick={(e) => {
                           e.preventDefault();
                           console.log(e);
                           console.log(selectedStatus);

                           let prevFilterParams = structuredClone(filterParams);
                           prevFilterParams["status2"] = prevFilterParams.status2.filter(
                              (item) => item != selectedStatus,
                           );
                           localStorage.setItem(lsOptionKey, JSON.stringify(prevFilterParams));
                           setFilterParams(prevFilterParams);
                        }}
                     >
                        {oOFields?.estate?.status2?.permittedvalues[selectedStatus]} {" ×"}
                     </button>
                  ))}
               </Form.Group>
            </Row>
            <Row>
               <Form.Group as={Col} controlId={"id_datumsfeld"} className="mb-2 mt-2">
                  <Form.Label>Sortieren nach</Form.Label>

                  <Form.Select onChange={(e) => changeFilterParams(e)} name="sortField" value={filterParams.sortField}>
                     <option value=""></option>
                     {[
                        ...(filterParams.dateField ? [filterParams.dateField] : []),
                        ...["objektnr_extern", "benutzer", config.estate.verkauftFur],
                     ].map((keyItem, index) => (
                        <option key={"_" + keyItem} value={keyItem}>
                           {oOFields?.estate[keyItem]?.label}
                        </option>
                     ))}
                  </Form.Select>
               </Form.Group>
               {/* <Col xs={12} md={4}> */}
               {config.company === "baur" && config.verkaufsDaten.quellen?.length > 0 && (
                  <Col>
                     {" "}
                     <MySelect
                        basicdata={filterParams}
                        data={{
                           name: "quelle",
                           heading: "Quellen (optional)",
                           options: config.verkaufsDaten.quellen,
                           optional: true,
                        }}
                        multiselect={"multi"}
                        changeData={changeFilterParams}
                        value={filterParams.quelle ?? ""}
                     />
                  </Col>
               )}
               {/* <Form.Group as={Col} controlId={"id_quelle"} className="mb-2 mt-2">
                     <Form.Label>Quelle</Form.Label>
                     <Form.Select name="quelle" value={filterParams.quelle} onChange={(e) => changeFilterParams(e)}>
                        <option></option>
                        {config.verkaufsDaten.quellen.map((keyItem, index) => (
                           <option key={"_" + keyItem} value={keyItem}>
                              {keyItem}
                           </option>
                        ))}
                     </Form.Select>
                  </Form.Group> */}
               {config.company === "bender" && (
                  <Col>
                     {" "}
                     <MySelect
                        basicdata={filterParams}
                        data={{
                           name: "quelle",
                           optional: true,

                           heading: "Quellen (optional)",
                           optionObject: oOFields?.estate?.[config.estate.quelle]?.permittedvalues ?? {},
                           // options: Object.keys(oOFields?.estate?.[config.estate.quelle]?.permittedvalues??{}),
                           // optionNames: Object.values(oOFields?.estate?.[config.estate.quelle]?.permittedvalues??{})
                        }}
                        // fieldconfiguration={oOFields?.estate?.[config.estate.quelle]}
                        multiselect={"multi"}
                        changeData={changeFilterParams}
                        value={filterParams.quelle ?? ""}

                        /* basicdata={data}
                                                         fieldconfiguration={
                                                            fieldconfiguration && fieldconfiguration[column.module][column.onOffice]
                                                         }
                                                         isPublished={dangerField === column.name}
                                                         multiselect={true}
                                                         data={column}
                                                         changeData={changeData}
                                                         value={data[column.name] ? data[column.name] : ""}
                                                         onOffice={true} */
                     />
                  </Col>
               )}
               {false && config.company === "bender" && (
                  <Form.Group as={Col} controlId={"id_quelle"} className="mb-2 mt-2">
                     <Form.Label>Quelle</Form.Label>
                     <Form.Select name="quelle" value={filterParams.quelle} onChange={(e) => changeFilterParams(e)}>
                        <option></option>
                        <option value=""></option>
                        {oOFields?.estate?.[config.estate.quelle] &&
                           Object.keys(oOFields?.estate?.[config.estate.quelle]?.permittedvalues)
                              .sort((a, b) =>
                                 oOFields?.estate?.[config.estate.quelle]?.permittedvalues[a] >
                                 oOFields?.estate?.[config.estate.quelle]?.permittedvalues[b]
                                    ? 1
                                    : -1,
                              )
                              .map((keyItem, index) => {
                                 return (
                                    <option key={"_" + keyItem} value={keyItem}>
                                       {oOFields?.estate?.[config.estate.quelle]?.permittedvalues[keyItem]}
                                    </option>
                                 );
                              })}
                     </Form.Select>
                  </Form.Group>
               )}
               {/* </Col> */}

               {users?.userList && (
                  <>
                     {/* <Form.Group as={Col} controlId={"id_datumsfeld"} className="mb-2 mt-2">
                        <Form.Label>Einkäufer (optional)</Form.Label>

                        <Form.Select
                           onChange={(e) => changeFilterParams(e)}
                           name={"einkaeufer"}
                           value={filterParams.einkaeufer}
                        >
                           <option value=""></option>
                           {users.userList.map((item, index) => (
                              <option key={"vk_" + item.id} value={item.id}>
                                 {item.Nachname + " " + item.Vorname}
                              </option>
                           ))}
                        </Form.Select>
                     </Form.Group> */}
                     {/* <Form.Group as={Col} controlId={"id_datumsfeld"} className="mb-2 mt-2">
                        <Form.Label>Verkäufer (optional)</Form.Label>

                        <Form.Select
                           onChange={(e) => changeFilterParams(e)}
                           name={"benutzer"}
                           value={filterParams.benutzer}
                        >
                           <option value=""></option>
                           {users.userList.map((item, index) => (
                              <option key={"vk_" + item.id} value={item.id}>
                                 {item.Nachname + " " + item.Vorname}
                              </option>
                           ))}
                        </Form.Select>
                     </Form.Group> */}
                  </>
               )}
            </Row>
            {users?.userList && (
               <Row>
                  <Col>
                     {" "}
                     <MySelect
                        basicdata={filterParams}
                        data={{
                           name: "einkaeufer",
                           optional: true,

                           heading: "Einkäufer (optional)",
                           optionObject: users.userList.reduce(
                              (oldObj, item) => ({ ...oldObj, [item.id]: item.Nachname + " " + item.Vorname }),
                              {},
                           ),
                        }}
                        multiselect={"multi"}
                        changeData={changeFilterParams}
                        value={filterParams.einkaeufer ?? ""}
                     />
                  </Col>
                  <Col>
                     {" "}
                     <MySelect
                        basicdata={filterParams}
                        data={{
                           name: "benutzer",
                           optional: true,

                           heading: "Verkäufer (optional)",
                           optionObject: users.userList.reduce(
                              (oldObj, item) => ({ ...oldObj, [item.id]: item.Nachname + " " + item.Vorname }),
                              {},
                           ),
                        }}
                        multiselect={"multi"}
                        changeData={changeFilterParams}
                        value={filterParams.benutzer ?? ""}
                     />
                  </Col>
               </Row>
            )}
            <hr />
            <Row>
               <Form.Group as={Col} controlId={"id_datumsfeld"} className="mb-2 mt-2">
                  <Form.Label>Datumsfeld</Form.Label>

                  <Form.Select
                     onChange={(e) => changeFilterParams(e)}
                     name={"dateField"}
                     value={filterParams.dateField}
                  >
                     <option value=""></option>
                     {oOFields &&
                        Object.keys(oOFields.estate)
                           .filter((keyItem) => oOFields.estate[keyItem].type === "date")
                           .map((keyItem, index) => (
                              <option key={"_" + keyItem} value={keyItem}>
                                 {oOFields.estate[keyItem].label}
                              </option>
                           ))}
                  </Form.Select>
               </Form.Group>
               <div className="col" style={{ position: "relative" }}>
                  <Form.Group as={Col} controlId={"id_date"} className="mb-2 mt-2">
                     <Form.Label>Startdatum</Form.Label>

                     <DatePicker
                        selected={filterParams.startDate}
                        showTimeSelect={false}
                        onChange={(value) => changeFilterParams(value, "startDate")}
                        className={"bootstrap-datepicker "}
                        calendarClassName="custom-date-calendar"
                        timeFormat="HH:mm"
                        dateFormat={"dd.MM.yyyy"}
                        locale="de"
                     />
                  </Form.Group>
                  <button
                     title="heute und jetzt als Datum einstellen"
                     className="now-button mt-2"
                     onClick={(e) => {
                        e.preventDefault();
                        changeFilterParams(new Date(), "startDate");
                     }}
                  >
                     {"˅"}
                  </button>
               </div>
               <div className="col" style={{ position: "relative" }}>
                  <Form.Group as={Col} controlId={"id_datee"} className="mb-2 mt-2">
                     <Form.Label>Enddatum</Form.Label>

                     <DatePicker
                        selected={filterParams.endDate}
                        showTimeSelect={false}
                        onChange={(value) => changeFilterParams(value, "endDate")}
                        className={"bootstrap-datepicker "}
                        calendarClassName="custom-date-calendar"
                        timeFormat="HH:mm"
                        dateFormat={"dd.MM.yyyy"}
                        locale="de"
                     />
                  </Form.Group>
                  <button
                     title="heute und jetzt als Datum einstellen"
                     className="now-button mt-2"
                     onClick={(e) => {
                        e.preventDefault();
                        changeFilterParams(new Date(), "endDate");
                     }}
                  >
                     {"˅"}
                  </button>
               </div>
            </Row>
            <Row>
               <Col xs={12} md={4}>
                  <Form.Group as={Col} controlId={"id_datumsfeld"} className="mb-2 mt-2">
                     <Form.Label> Datumsfeld 2 (optional mit UND-Verknüpfung)</Form.Label>

                     <Form.Select
                        onChange={(e) => changeFilterParams(e)}
                        name={"dateField2"}
                        value={filterParams.dateField2}
                     >
                        <option value=""></option>
                        {oOFields &&
                           Object.keys(oOFields.estate)
                              .filter((keyItem) => oOFields.estate[keyItem].type === "date")
                              .map((keyItem, index) => (
                                 <option key={"_" + keyItem} value={keyItem}>
                                    {oOFields.estate[keyItem].label}
                                 </option>
                              ))}
                     </Form.Select>
                  </Form.Group>
               </Col>
               {filterParams.dateField2 && (
                  <>
                     <Col xs={12} md={4}>
                        <div style={{ position: "relative" }}>
                           <Form.Group as={Col} controlId={"id_date2"} className="mb-2 mt-2">
                              <Form.Label>
                                 {oOFields?.estate?.[filterParams.dateField2]?.label ?? ""}-Startdatum{" "}
                              </Form.Label>

                              <DatePicker
                                 selected={filterParams.startDate2}
                                 showTimeSelect={false}
                                 onChange={(value) => changeFilterParams(value, "startDate2")}
                                 className={"bootstrap-datepicker "}
                                 calendarClassName="custom-date-calendar"
                                 timeFormat="HH:mm"
                                 dateFormat={"dd.MM.yyyy"}
                                 locale="de"
                              />
                           </Form.Group>
                           <button
                              title="heute und jetzt als Datum einstellen"
                              className="now-button"
                              onClick={(e) => {
                                 e.preventDefault();
                                 changeFilterParams(new Date(), "startDate2");
                              }}
                           >
                              {"˅"}
                           </button>
                        </div>
                     </Col>
                     <Col xs={12} md={4}>
                        <div style={{ position: "relative" }}>
                           <Form.Group as={Col} controlId={"id_datee2"} className="mb-2 mt-2">
                              <Form.Label>
                                 {oOFields?.estate?.[filterParams.dateField2]?.label ?? ""}-Enddatum{" "}
                              </Form.Label>

                              <DatePicker
                                 selected={filterParams.endDate2}
                                 showTimeSelect={false}
                                 onChange={(value) => changeFilterParams(value, "endDate2")}
                                 className={"bootstrap-datepicker "}
                                 calendarClassName="custom-date-calendar"
                                 timeFormat="HH:mm"
                                 dateFormat={"dd.MM.yyyy"}
                                 locale="de"
                              />
                           </Form.Group>
                           <button
                              title="heute und jetzt als Datum einstellen"
                              className="now-button"
                              onClick={(e) => {
                                 e.preventDefault();
                                 changeFilterParams(new Date(), "endDate2");
                              }}
                           >
                              {"˅"}
                           </button>
                        </div>
                     </Col>
                  </>
               )}
            </Row>
            {estateData && (
               <div
                  className="text-end mb-4 p-2 px-4"
                  style={{ background: "#222", color: "#fff", borderRadius: "10px" }}
               >
                  <span>
                     Anzahl Objekte, bei denen das{" "}
                     <strong>{oOFields?.estate?.[filterParams.dateField]?.label ?? ""}</strong>{" "}
                     {filterParams.dateField2 && (
                        <span>
                           {" "}
                           und <strong>{oOFields?.estate?.[filterParams.dateField2]?.label ?? ""}</strong>
                        </span>
                     )}{" "}
                     im ausgewählten Zeitbereich liegt: <strong>{estateData.length}</strong>
                  </span>
               </div>
            )}
            <Row>
               <Col xs={12} md={4}>
                  <Form.Group as={Col} controlId={"id_datumsfeld"} className="mb-2 mt-2">
                     <Form.Label>Terminarten</Form.Label>
                     <Form.Select
                        value={filterParams.terminArten}
                        name="terminArten"
                        onChange={(e) => changeFilterParams(e)}
                     >
                        <option></option>
                        {config.verkaufsDaten.terminArten.map((keyItem, index) => (
                           <option key={"_" + keyItem} value={keyItem}>
                              {keyItem}
                           </option>
                        ))}
                     </Form.Select>
                  </Form.Group>
               </Col>
               {filterParams.terminArten && (
                  <>
                     <Col xs={12} md={4}>
                        <div style={{ position: "relative" }}>
                           <Form.Group controlId={"id_datest"} className="mb-2 mt-2">
                              <Form.Label>{filterParams.terminArten} Startdatum</Form.Label>

                              <DatePicker
                                 selected={filterParams.startDateTermin}
                                 showTimeSelect={false}
                                 onChange={(value) => changeFilterParams(value, "startDateTermin")}
                                 className={"bootstrap-datepicker "}
                                 calendarClassName="custom-date-calendar"
                                 timeFormat="HH:mm"
                                 dateFormat={"dd.MM.yyyy"}
                                 locale="de"
                              />
                           </Form.Group>
                           <button
                              title="heute und jetzt als Datum einstellen"
                              className="now-button"
                              onClick={(e) => {
                                 e.preventDefault();
                                 changeFilterParams(new Date(), "startDateTermin");
                              }}
                           >
                              {"˅"}
                           </button>
                        </div>
                     </Col>
                     <Col xs={12} md={4}>
                        <div style={{ position: "relative" }}>
                           <Form.Group controlId={"id_dateet"} className="mb-2 mt-2">
                              <Form.Label>{filterParams.terminArten} Enddatum</Form.Label>

                              <DatePicker
                                 selected={filterParams.endDateTermin}
                                 showTimeSelect={false}
                                 onChange={(value) => changeFilterParams(value, "endDateTermin")}
                                 className={"bootstrap-datepicker "}
                                 calendarClassName="custom-date-calendar"
                                 timeFormat="HH:mm"
                                 dateFormat={"dd.MM.yyyy"}
                                 locale="de"
                              />
                           </Form.Group>
                           <button
                              title="heute und jetzt als Datum einstellen"
                              className="now-button"
                              onClick={(e) => {
                                 e.preventDefault();
                                 changeFilterParams(new Date(), "endDateTermin");
                              }}
                           >
                              {"˅"}
                           </button>
                        </div>
                     </Col>
                  </>
               )}
            </Row>

            {terminData && (
               <div
                  className="text-end mb-4 p-2 px-4"
                  style={{ background: "#222", color: "#fff", borderRadius: "10px" }}
               >
                  {(() => {
                     const gesamtTermine = terminData.reduce((oldItem, item) => oldItem + item.graph.Anzahl, 0);
                     return (
                        <div>
                           Gesamttermine:
                           <strong className="mx-1">{gesamtTermine}</strong>| davon erfüllen Filterkriterien:{" "}
                           <strong className="mx-1">
                              {terminEstateData?.length} Stk. |{" "}
                              {Math.round((terminEstateData?.length / gesamtTermine) * 1000) / 10}%
                           </strong>
                        </div>
                     );
                  })()}
               </div>
            )}
            <div className="text-end">
               <Button
                  className="ms-2 px-5"
                  variant="outline-dark"
                  onClick={() => {
                     setFilterParams(initialFilterParams);
                  }}
               >
                  Felder zurücksetzen
               </Button>
               <Button
                  className="ms-2 px-5"
                  disabled={!(filterParams.dateField || filterParams.vollmachtsdatum)}
                  onClick={() => {
                     getData();
                     getTerminData();
                  }}
               >
                  Daten laden
               </Button>
            </div>
         </Form>

         <div className="flex-row mx-5" style={{ minHeight: "600px" }}>
            {accData && (
               <div style={{ height: 400, padding: "0px 20px", flex: 1 }}>
                  <h2>Verkauftpreis im Vergleich zur Schätzspanne</h2>

                  <ResponsiveContainer width="100%" height="100%">
                     <PieChart>
                        <Tooltip />
                        <Legend
                           formatter={(value, props) => {
                              return `${value} ${props.payload.value}`;
                           }}
                        />

                        <Pie
                           data={Object.values(accData)}
                           dataKey="value"
                           nameKey="name"
                           cx="50%" // Zentrum auf der X-Achse (mittig)
                           cy="50%" // Zentrum auf der Y-Achse (mittig)
                           outerRadius={150} // Größe der Torte
                           fill="#8884d8"
                           label={(entry) =>
                              `${entry.name}: ${entry.value} ${entry.abweichung ? "| Abweichung: " + Math.round((entry.abweichung / entry.value) * 10) / 10 + " %" : ""}`
                           } // Zeigt Text direkt an den Stücken an
                        >
                           {/* Hier weisen wir jedem Tortenstück seine spezifische Farbe zu */}
                           {Object.values(accData).map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry?.color ?? "#f0f"} />
                           ))}
                        </Pie>
                     </PieChart>
                  </ResponsiveContainer>
               </div>
            )}
            {vkStatusData && (
               <div style={{ position: "relative", height: 400, padding: "0px 20px", flex: 1 }}>
                  <Button
                     variant="dark"
                     onClick={() => {
                        setShowDetails((prev) => ({ ...prev, verkaufsstatus: !prev.verkaufsstatus }));
                     }}
                     style={{ zIndex: 1, position: "absolute", left: 0, margin: "60px 20px" }}
                  >
                     Details {showDetails.verkaufsstatus ? "verbergen" : "anzeigen"}
                  </Button>
                  <h2>Aktueller Verkaufsstatus</h2>

                  <ResponsiveContainer width="100%" height="100%">
                     <PieChart>
                        <Tooltip
                           formatter={(value, name, props) => {
                              if (value)
                                 return [
                                    `${value} | ${Math.round((100 * value) / estateData.length)}% | ${props.payload?.objektnr_extern?.join(", ") ?? name}`,
                                    oOFields?.estate?.status2?.permittedvalues[name],
                                 ];
                           }}
                        />
                        <Legend
                           formatter={(value, props) => {
                              if (props.payload.value)
                                 return `${oOFields?.estate?.status2?.permittedvalues[value] ?? value} ${props.payload.value} | ${Math.round((100 * props.payload.value) / estateData.length)}%`;
                           }}
                        />
                        {showDetails.verkaufsstatus && accVkStatusData && accVkStatusData ? (
                           <Pie
                              data={Object.values(vkStatusData)}
                              dataKey="value"
                              nameKey="name"
                              animationDuration={300}
                              animationBegin={0}
                              // animationEasing="ease"
                              cx="50%" // Zentrum auf der X-Achse (mittig)
                              cy="50%" // Zentrum auf der Y-Achse (mittig)
                              outerRadius={140} // Größe der Torte
                              fill="#8884d8"
                              // label={(entry) => `${entry.name}: ${entry.value} ${JSON.stringify(entry)}`}
                           >
                              {/* Hier weisen wir jedem Tortenstück seine spezifische Farbe zu */}
                              {Object.values(vkStatusData).map((entry, index) => (
                                 <Cell key={`cell-${index}`} fill={entry?.color ?? "#f0f"} />
                              ))}
                           </Pie>
                        ) : (
                           <Pie
                              data={Object.values(accVkStatusData)}
                              dataKey="value"
                              animationBegin={0}
                              animationDuration={300}
                              nameKey="name"
                              cx="50%" // Zentrum auf der X-Achse (mittig)
                              cy="50%" // Zentrum auf der Y-Achse (mittig)
                              // innerRadius={120} // Größe der Torte
                              outerRadius={160} // Größe der Torte
                              fill="#8884d8"
                              label={(entry) => {
                                 if (entry.value)
                                    return `${entry.name}: ${entry.value} | ${Math.round((100 * entry.value) / estateData.length)}%`;
                              }}
                              // label={(entry) => `${entry.name}: ${entry.value} ${JSON.stringify(entry)}`}
                           >
                              {Object.values(accVkStatusData).map((entry, index) => (
                                 <Cell key={`cell-${index}`} fill={entry?.color ?? "#f0f"} />
                              ))}
                           </Pie>
                        )}
                     </PieChart>
                  </ResponsiveContainer>
               </div>
            )}
            {quelleData && (
               <div style={{ position: "relative", height: 400, padding: "0px 20px", flex: 1 }}>
                  <Button
                     variant="dark"
                     onClick={() => {
                        setShowDetails((prev) => ({ ...prev, quelle: !prev.quelle }));
                     }}
                     style={{ zIndex: 1, position: "absolute", left: 0, margin: "60px 20px" }}
                  >
                     Details {showDetails.quelle ? "verbergen" : "anzeigen"}
                  </Button>
                  <h2>Quelle</h2>

                  <ResponsiveContainer width="100%" height="100%">
                     <PieChart>
                        <Tooltip
                           formatter={(value, name, props) => [
                              `${value} | ${Math.round((100 * value) / estateData.length)}% | ${props.payload.objektnr_extern.join(", ")}`,
                              name,
                           ]}
                        />
                        <Legend
                           formatter={(value, props) => {
                              return `${value} ${props.payload.value} | ${Math.round((100 * props.payload.value) / estateData.length)}%`;
                           }}
                        />

                        {showDetails.quelle && quelleData && accQuelleData ? (
                           <Pie
                              data={quelleData}
                              dataKey="value"
                              nameKey="name"
                              animationBegin={0}
                              animationDuration={300}
                              cx="50%" // Zentrum auf der X-Achse (mittig)
                              cy="50%" // Zentrum auf der Y-Achse (mittig)
                              outerRadius={120} // Größe der Torte
                              fill="#8884d8"
                           >
                              {/* Hier weisen wir jedem Tortenstück seine spezifische Farbe zu */}
                              {quelleData.map((entry, index) => (
                                 <Cell key={`cell0-${index}`} fill={entry?.color ?? "#f0f"} />
                              ))}
                           </Pie>
                        ) : (
                           <Pie
                              data={accQuelleData}
                              dataKey="value"
                              nameKey="name"
                              animationBegin={0}
                              animationDuration={300}
                              cx="50%" // Zentrum auf der X-Achse (mittig)
                              cy="50%" // Zentrum auf der Y-Achse (mittig)
                              outerRadius={150} // Größe der Torte
                              fill="#8884d8"
                              // label={(entry) => `${entry.name}: ${entry.value} ${JSON.stringify(entry)}`}
                           >
                              {/* Hier weisen wir jedem Tortenstück seine spezifische Farbe zu */}
                              {accQuelleData.map((entry, index) => (
                                 <Cell key={`cell1-${index}`} fill={entry?.color ?? "#f0f"} />
                              ))}
                           </Pie>
                        )}
                     </PieChart>
                  </ResponsiveContainer>
               </div>
            )}
         </div>
         {estateData && (
            <div
               className="flex-row mx-5 py-4"
               style={
                  {
                     /* minHeight: "500px" */
                  }
               }
            >
               <>
                  {config.company === "baur" && (
                     <div
                        style={{ /*  minWidth: "50%", maxWidth: "100%", */ height: 350, padding: "0px 20px", flex: 1 }}
                     >
                        <h2>
                           Abweichung vom Grenzwert <small>in %</small>
                        </h2>
                        <ResponsiveContainer width="100%" height="100%">
                           <AreaChart
                              data={estateData
                                 .filter((item) => Number.isFinite(item.abweichungGrenzwert))
                                 .sort((a, b) => a.abweichungGrenzwert - b.abweichungGrenzwert)}
                              margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                           >
                              <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                              <XAxis dataKey="name" type="category" hide />
                              <YAxis domain={[-30, 30]} />
                              <Tooltip
                                 formatter={(value) => [`${value}%`, "Abweichung"]}
                                 labelFormatter={(label) => `${label}`}
                              />

                              <Area
                                 type="monotone"
                                 dataKey="abweichungGrenzwert"
                                 fill="url(#splitColor)"
                                 // stroke="#c30" // Indigo farbene Linie
                                 // fill="#fdd" // Hellblau/Indigo Füllung
                                 strokeWidth={2}
                                 dot={false} // Keine Punkte auf der Kurve, um sie clean zu halten
                              />
                           </AreaChart>
                        </ResponsiveContainer>
                     </div>
                  )}
                  {filterParams.dateField && filterParams.dateField2 && (
                     <div style={{ position: "relative", height: 350, padding: "0px 20px", flex: 1 }}>
                        <h2>
                           Zeitspanne <strong>{oOFields?.estate?.[filterParams.dateField]?.label ?? ""}</strong> bis{" "}
                           <strong>{oOFields?.estate?.[filterParams.dateField2]?.label ?? ""}</strong>
                        </h2>
                        <div style={{ position: "absolute" }}>
                           Anzahl: <strong className="mx-1">{estateData.length}</strong>
                           Durchschnitt:
                           <strong className="mx-1">
                              {Math.round(
                                 estateData.reduce((oldItem, item) => oldItem + (item?.zeitSpanne || 0), 0) /
                                    estateData.length,
                              )}
                           </strong>
                           Tage | Median:
                           <strong className="mx-1">
                              {estateData.filter((item) => item.zeitSpanne).sort((a, b) => a.zeitSpanne - b.zeitSpanne)[
                                 Math.round(estateData.length / 2)
                              ]?.zeitSpanne || "-"}
                           </strong>
                           Tage
                        </div>
                        <ResponsiveContainer width="100%" height="100%">
                           <AreaChart
                              data={estateData
                                 .filter((item) => Number.isFinite(item.zeitSpanne))
                                 .sort((a, b) => a.zeitSpanne - b.zeitSpanne)}
                              margin={{ top: 40, right: 30, left: 20, bottom: 50 }}
                           >
                              <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                              <XAxis dataKey="name" type="category" hide />
                              <YAxis />

                              <Tooltip
                                 formatter={(value) => [`${value}`, "Zeitspanne"]}
                                 labelFormatter={(label) => `${label}`}
                              />

                              <Area
                                 type="monotone"
                                 dataKey="zeitSpanne"
                                 stroke="#c30" // Indigo farbene Linie
                                 fill="#fdd" // Hellblau/Indigo Füllung
                                 strokeWidth={2}
                                 dot={true} // Keine Punkte auf der Kurve, um sie clean zu halten
                              />
                           </AreaChart>
                        </ResponsiveContainer>
                     </div>
                  )}
                  {filterParams.dateField &&
                     config.company === "baur" &&
                     (() => {
                        const arrayLength = estateData.filter((item) => item.ekZeitSpanne).length;
                        return (
                           <div style={{ position: "relative", height: 350, padding: "0px 20px", flex: 1 }}>
                              <h2>
                                 Zeitspanne <strong>Einkaufstermin</strong> bis{" "}
                                 <strong>{oOFields?.estate?.[filterParams.dateField]?.label ?? ""}</strong>{" "}
                              </h2>
                              <div style={{ position: "absolute" }}>
                                 Anzahl: <strong className="mx-1">{arrayLength}</strong>
                                 Durchschnitt:
                                 <strong className="mx-1">
                                    {Math.round(
                                       estateData.reduce((oldItem, item) => oldItem + (item?.ekZeitSpanne || 0), 0) /
                                          arrayLength,
                                    )}
                                 </strong>
                                 Tage | Median:
                                 <strong className="mx-1">
                                    {estateData
                                       .filter((item) => item.ekZeitSpanne)
                                       .sort((a, b) => a.ekZeitSpanne - b.ekZeitSpanne)[Math.round(arrayLength / 2)]
                                       ?.ekZeitSpanne || "-"}
                                 </strong>
                                 Tage
                              </div>
                              <ResponsiveContainer width="100%" height="100%">
                                 <AreaChart
                                    data={estateData
                                       .filter((item) => Number.isFinite(item.ekZeitSpanne))
                                       .sort((a, b) => a.ekZeitSpanne - b.ekZeitSpanne)}
                                    margin={{ top: 40, right: 30, left: 20, bottom: 40 }}
                                 >
                                    <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                                    <XAxis dataKey="name" type="category" hide />
                                    <YAxis />

                                    <Tooltip
                                       formatter={(value) => [`${value}`, "Zeitspanne"]}
                                       labelFormatter={(label) => `${label}`}
                                    />

                                    <Area
                                       type="monotone"
                                       dataKey="ekZeitSpanne"
                                       stroke="#c30" // Indigo farbene Linie
                                       fill="#fdd" // Hellblau/Indigo Füllung
                                       strokeWidth={2}
                                       dot={true} // Keine Punkte auf der Kurve, um sie clean zu halten
                                    />
                                 </AreaChart>
                              </ResponsiveContainer>
                           </div>
                        );
                     })()}
               </>
            </div>
         )}
         {terminData && (
            <div className="m-5" style={{ position: "relative", height: 350, padding: "0px 20px", flex: 1 }}>
               <h2>Anzahl der {filterParams.terminArten}</h2>
               {(() => {
                  const gesamtTermine = terminData.reduce((oldItem, item) => oldItem + item.graph.Anzahl, 0);
                  console.log(terminData);

                  const userEstates = filterParams.einkaeufer.map((ekUserId) => ({
                     userId: ekUserId,
                     termine: terminData.reduce((oldItem, item) => oldItem + (item.graph[ekUserId] ?? 0), 0),
                     estates: terminEstateData?.filter(
                        (item) => item?.elements?.[config.estate.einkaeufer] === ekUserId,
                     ).length,
                  }));
                  console.log(terminEstateData);

                  console.log(userEstates);

                  return (
                     <div style={{ position: "absolute" }}>
                        Gesamt: {/* Anzahl der {filterParams.terminArten.join(", ")} | Gesamt:{" "} */}
                        <strong className="mx-1">{gesamtTermine}</strong>| davon erfüllen Filterkriterien:{" "}
                        <strong className="mx-1">
                           {terminEstateData?.length} Stk. |{" "}
                           {Math.round((terminEstateData?.length / gesamtTermine) * 1000) / 10}%
                        </strong>
                        {userEstates.map((userData) => {
                           return (
                              <span className="mx-1">
                                 {users.userObject[userData.userId].Name} Objekte: {userData.estates} Termine:{" "}
                                 {userData.termine}
                              </span>
                           );
                        })}
                     </div>
                  );
               })()}

               <ResponsiveContainer width="100%" height="100%">
                  <ComposedChart
                     data={terminData.map((item) => item.graph)}
                     margin={{ top: 40, right: 30, left: 20, bottom: 20 }}
                  >
                     <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                     <XAxis dataKey="name" type="category" />
                     <YAxis />
                     <Tooltip content={<CustomTooltip userObject={users.userObject} />} />
                     <Bar
                        dataKey="Anzahl"
                        barSize={4}
                        stroke="#b91b92"
                        fill="#b91b92"
                        fillOpacity={0.4}
                        strokeWidth={2}
                     >
                        <LabelList dataKey="Anzahl" stroke="#b91b92" position="top" formatter={(v) => `${v}`} />
                     </Bar>
                     {users.userList.map((usrItem) => {
                        return (
                           <Bar
                              barSize={20}
                              stackId="barStack"
                              dataKey={usrItem.id}
                              stroke="#b91b92"
                              fill="#72235e"
                              fillOpacity={1}
                              strokeWidth={2}
                              // label={(entry) => `${entry}`}
                           >
                              {/* <LabelList
                                 dataKey={usrItem.id}
                                 stroke="#fff"
                                 fontSize={10}
                                 strokeWidth={1}
                                 position="center"
                                 formatter={(v) => `${v}`}
                              /> */}
                           </Bar>
                        );
                     })}
                  </ComposedChart>
               </ResponsiveContainer>
            </div>
         )}
         {terminData &&
            terminEstateData?.length > 0 &&
            (() => {
               const gesamtTermine = terminData.reduce((oldItem, item) => oldItem + item.graph.Anzahl, 0);
               console.log(terminData);

               const myData = users.userList
                  .map((user) => {
                     const userObjekte = terminEstateData?.filter(
                        (item) => item?.elements?.[config.estate.einkaeufer] === user.id,
                     ).length;
                     const userTermine = terminData.reduce((oldItem, item) => oldItem + (item.graph[user.id] ?? 0), 0);
                     return {
                        userId: user.id,
                        name: user.Kuerzel,
                        Termine: userTermine,
                        Terminanzahl: userTermine.length,
                        Objektanuahl: userObjekte.length,
                        Objekte: userObjekte,
                        Quote: Math.round((userObjekte / userTermine) * 1000) / 10,
                        ...terminEstateData
                           ?.filter((item) => item?.elements?.[config.estate.einkaeufer] === user.id)
                           ?.reduce(
                              (oldObj, item) => ({
                                 ...oldObj,
                                 [item.elements.status2]: 1 + (oldObj[item.elements.status2] ?? 0),
                              }),
                              {},
                           ),
                     };
                  })
                  .filter((item) => item?.Objekte > 0);

               return (
                  <div
                     className="m-5"
                     style={{ position: "relative", /* width: "50%", */ height: 550, padding: "0px 20px", flex: 1 }}
                  >
                     <h2>
                        Anzahl der Objekte mit Terminart: <small>{filterParams.terminArten}</small> | Quote | Anzahl der
                        Termine
                     </h2>

                     <div style={{ position: "absolute", width: "100%", padding: 20, top: "30px" }}>
                        Gesamt: {/* Anzahl der {filterParams.terminArten.join(", ")} | Gesamt:{" "} */}
                        <strong className="mx-1">{gesamtTermine}</strong>| davon erfüllen Filterkriterien:{" "}
                        <strong className="mx-1">
                           {terminEstateData?.length} Stk. |{" "}
                           {Math.round((terminEstateData?.length / gesamtTermine) * 1000) / 10}%
                        </strong>
                        <div className="flex-row" style={{ flexWrap: "wrap" }}>
                           {myData
                              .sort((a, b) => (a[sortTerminResultKey] > b[sortTerminResultKey] ? -1 : 1))
                              .map((userData, index) => {
                                 return (
                                    <div
                                       className="m-2 px-1"
                                       style={{
                                          outline: "solid 4px " + colorPalette100[index],
                                          background: colorPalette100[index] + "ff",
                                          color: "#fff",
                                          fontWeight: 700,
                                       }}
                                       title={users.userObject[userData.userId].Name}
                                    >
                                       {`${users.userObject[userData.userId].Name}: ${userData.Termine} | ${userData.Objekte} | ${userData.Quote}%`}
                                    </div>
                                 );
                              })}
                        </div>
                     </div>

                     <ResponsiveContainer width="100%" height="100%">
                        <div style={{ position: "absolute", right: 147, bottom: "calc(50% - 100px)", zIndex: 1 }}>
                           <button
                           onClick={()=>{setSortTerminResultKey("Objekte")}}
                              style={{
                                 transform: "rotate(-90deg)",
                                 border: "none",
                                 boxShadow: "0 0 8px #0009",
                                 ...(sortTerminResultKey === "Objekte"
                                    ? { background: "#333", color: "#fff" }
                                    : { background: "#fff", color: "#000" }),
                              }}
                           >
                              Anzahl Objekte
                           </button>
                        </div>
                        <div style={{ position: "absolute", right: 100, bottom: "calc(50% - 100px)", zIndex: 1 }}>
                           <button
                           onClick={()=>{setSortTerminResultKey("Quote")}}
                              style={{
                                 transform: "rotate(-90deg)",
                                 border: "none",
                                 boxShadow: "0 0 8px #0009",
                                 ...(sortTerminResultKey === "Quote"
                                    ? { background: "#333", color: "#fff" }
                                    : { background: "#fff", color: "#000" }),
                              }}
                           >
                              Quote in [%]
                           </button>
                        </div>
                        <div style={{ position: "absolute", right: 26, bottom: "calc(50% - 100px)", zIndex: 1 }}>
                           <button
                           onClick={()=>{setSortTerminResultKey("Termine")}}
                              style={{
                                 transform: "rotate(-90deg)",
                                 border: "none",
                                 boxShadow: "0 0 8px #0009",
                                 ...(sortTerminResultKey === "Termine"
                                    ? { background: "#333", color: "#fff" }
                                    : { background: "#fff", color: "#000" }),
                              }}
                           >
                              Anzahl Termine
                           </button>
                        </div>
                        <ComposedChart data={myData} margin={{ top: 120, right: 30, left: 20, bottom: 20 }}>
                           <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                           <XAxis dataKey="name" type="category" />
                           <YAxis
                              yAxisId="Objekte"
                              orientation="right"
                              stroke="#000"
                              /* label={{
                                 // value: "Objekte",
                                 value: " ",
                                 angle: -90,
                                 position: "insideLeft",
                                 fontWeight: 700,
                                 fontSize: 20,
                                 offset: 40, // negativer Wert schiebt es weiter NACH AUSSEN
                                 style: { textAnchor: "middle" },
                              }} */
                           />
                           <YAxis
                              yAxisId="Quote"
                              orientation="right"
                              onClick={() => {
                                 setSortTerminResultKey("Quote");
                              }}
                              stroke="#000"
                              /*  label={{
                                 fontSize: 20,
                                 value: "Quote [%]",
                                 fontWeight: 500,
                                 angle: -90,
                                 position: "insideLeft",
                                 offset: 40, // negativer Wert schiebt es weiter NACH AUSSEN
                                 style: { textAnchor: "middle" },
                              }} */
                           />
                           <YAxis
                              yAxisId="Termine"
                              orientation="right"
                              onClick={() => {
                                 setSortTerminResultKey("Termine");
                              }}
                              stroke="#000"
                              /*  label={{
                                 fontWeight: 500,
                                 fontSize: 20,
                                 value: "Termine",
                                 angle: -90,
                                 position: "insideLeft",
                                 offset: 40, // negativer Wert schiebt es weiter NACH AUSSEN
                                 style: { textAnchor: "middle" },
                              }} */
                           />

                           <Tooltip
                              formatter={(value, name, props) => {
                                 if (value)
                                    return [`${value}`, oOFields?.estate?.status2?.permittedvalues[name] ?? name];
                              }}
                           />
                           {Object.keys(oOFields?.estate?.status2?.permittedvalues).map((item) => {
                              const color = config.verkaufsDaten.tortenStatus[item]?.color ?? "#0ff";

                              return (
                                 <Bar
                                    yAxisId="Objekte"
                                    stackId={"vkDaten"}
                                    dataKey={item}
                                    barSize={26}
                                    stroke="#555"
                                    fill={color}
                                    fillOpacity={0.7}
                                    strokeWidth={0.1}
                                 >
                                    <LabelList
                                       dataKey={item}
                                       stroke="#000"
                                       position="center"
                                       formatter={(v) => `${v}`}
                                    />
                                 </Bar>
                              );
                           })}
                           <Bar
                              dataKey="Objekte"
                              yAxisId="Objekte"
                              barSize={0}
                              strokeWidth={1}
                              label={(props) => {
                                 const { x, y, width, value, payload, index, name } = props;
                                 return (
                                    <text
                                       x={x + width - 16}
                                       y={y - 6}
                                       textAnchor="middle"
                                       fill={colorPalette100[index]}
                                       fontSize={14}
                                       fontWeight={700}
                                    >
                                       {`${value}`}
                                    </text>
                                 );
                              }}
                           ></Bar>
                           <Bar
                              dataKey="Quote"
                              yAxisId="Quote"
                              barSize={20}
                              strokeWidth={1}
                              label={(props) => {
                                 const { x, y, width, value, payload, index, name } = props;

                                 return (
                                    <text
                                       x={x + width / 2}
                                       y={y - 6}
                                       textAnchor="middle"
                                       fill={colorPalette100[index]}
                                       fontSize={14}
                                       fontWeight={700}
                                    >
                                       {`${myData[index].Quote}%`}
                                    </text>
                                 );
                              }}
                           >
                              {myData.map((entry, index) => (
                                 <Cell key={`cell-${index}`} fill={colorPalette100[index]} />
                              ))}
                           </Bar>
                           <Bar
                              dataKey="Termine"
                              yAxisId="Termine"
                              barSize={20}
                              strokeWidth={1}
                              label={(props) => {
                                 const { x, y, width, value, payload, index, name } = props;

                                 return (
                                    <text
                                       x={x + width / 2}
                                       y={y - 6}
                                       textAnchor="middle"
                                       fill={colorPalette100[index]}
                                       fontSize={14}
                                       fontWeight={700}
                                    >
                                       {`${value}`}
                                    </text>
                                 );
                              }}
                           >
                              {myData.map((entry, index) => (
                                 <Cell key={`cell-${index}`} fill={colorPalette100[index]} />
                              ))}
                           </Bar>
                        </ComposedChart>
                     </ResponsiveContainer>
                  </div>
               );
            })()}
         {tableData && (
            <VerkaufsdatenTable
               users={users}
               oOFields={oOFields}
               tableData={tableData}
               setTableData={setTableData}
            />
         )}
         {estateData && <VerkaufsdatenPreisSpanne accData={accData} estateData={estateData} />}
      </div>
   );
}
